import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import * as Models from '../../models/models-index';
import { RuntimeConfigService } from '../services-index';
import { BasePagedSortableRequest } from '../../models/models-index';

@Injectable({ providedIn: 'root' })
export class UsersService {
  private apiUrl = environment.baseV5ApiUri + '/users';

  headers = { 'Content-Type': 'application/json' };

  constructor(
    private http: HttpClient,
    private configService: RuntimeConfigService) { }

  getUsers(reportRequest: BasePagedSortableRequest): Observable<Models.UserResponseModel> {
    let params = new HttpParams();
    for (const [key, value] of Object.entries(reportRequest)) {
      if (value !== undefined && value !== null && value !== '') {
        params = params.append(key, value.toString());
      }
    }

    return this.http.get<Models.UserResponseModel>(
      this.apiUrl, { params }
    );
  }

  getById(id: string): Observable<Models.User> {
    return this.http.get<Models.User>(`${this.apiUrl}/${id}`, { headers: this.headers });
  }

  getUser(id: string, headers?: HttpHeaders | { [header: string]: string | string[] }): Observable<Models.ReportingUser> {
    return this.http.get<Models.ReportingUser>(this.configService.config.apiUri + 'users/' + id, { headers: headers ?? this.headers });
  }

  getUserByUserName(request: string): Observable<Models.User> {
    const requestModel: Models.UserByNameRequestModel = {
      userName: request
    };

    return this.http.post<Models.User>(environment.baseApiUri + '/getUserByName', requestModel, { headers: this.headers });
  }

  getRoles(): Observable<Models.Role[]> {
    return this.http.get<Models.Role[]>(this.apiUrl + '/roles', { headers: this.headers });
  }

  getOrgLookupTypes(): Observable<Models.OrgLookupType[]> {
    return this.http.get<Models.OrgLookupType[]>(`${this.apiUrl}/orgLookupTypes`, { headers: this.headers });
  }

  getHarmonyRedirectUrl(): Observable<any> {
    return this.http.get<any>(environment.baseV5ApiUri + '/users/harmony-redirect-url', { headers: this.headers });
  }

  getMysteryShopRedirectUrl(): Observable<any> {
    return this.http.get<any>(environment.baseV5ApiUri + '/users/mystery-shop-redirect-url', { headers: this.headers });
  }

  getAuthProviders(): Observable<string[]> {
    return this.http.get<string[]>(`${this.apiUrl}/auth-providers`, { headers: this.headers });
  }

  create(user: Models.UserRequest): Observable<void> {
    return this.http.post<void>(this.apiUrl, user, { headers: this.headers });
  }

  update(id: string, user: Models.UserRequest): Observable<void> {
    return this.http.put<void>(`${this.apiUrl}/${id}`, user, { headers: this.headers });
  }

  validateRoleEntity(roleEntity: string | null, roleNames: string[]): Observable<{ isValid: boolean; message?: string | null }> {
    const payload = { roleEntity: roleEntity, roleNames: roleNames };
    return this.http.post<{ isValid: boolean; message?: string | null }>(`${this.apiUrl}/validate-role-entity`, payload, { headers: this.headers });
  }

  import(file: File): Observable<void> {
    const formData = new FormData();
    formData.append('file', file);

    return this.http.post<void>(`${this.apiUrl}/import`, formData);
  }

  delete(id: string): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${id}`);
  }
}
